import { isPublic } from '@core/router/utils';
import store from '@core/store';
import { Auth } from '@core/auth';

import Investor from '@/models/Investor';

const setOrganisation = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (!auth.organisation_id) {
            auth.investor = null;
        } else if (auth.is_investor) {
            try {
                // CP-4378 We have to get the latest investor data to check portfolio_restriction_status
                const investor = await Investor.$get(auth.organisation_id, { force: true });
                auth.investor = investor;
            } catch (error) {
                console.error(error);
                auth.investor = null;
            }
        } else if ((to.query.organisation_type === 'investor' && to.query.organisation_id) || to.query.investor_id) {
            if (!to.name.startsWith('Settings')) {
                try {
                    const investorId = to.query.organisation_id || to.query.investor_id;
                    const investor = await Investor.$get(investorId, { force: true });
                    store.dispatch('app/addQuerySelector', {
                        key: 'investor_id',
                        value: investorId,
                        data: investor
                    });
                } catch (error) {
                    console.error(error);
                }
            }
        }

        next();
    }
};

export default setOrganisation;
